import React, { Component } from 'react';
import { Card, Icon, Tooltip } from 'material-ui';
import { withStyles } from 'material-ui/styles/index';
import axios from 'axios';

const styles = theme => ({
    root: {}
});

function Marker({ text }) {

    return (
        <Tooltip title={text} placement="top">
            <Icon className="text-red">place</Icon>
        </Tooltip>
    );
}

class Widget16 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            imageURL1Week: 'assets/images/default-avatar.png',
            imageURL2Week: 'assets/images/default-avatar.png',
            imageURL3Week: 'assets/images/default-avatar.png',

            name1Week: "",
            name2Week: "",
            name3Week: "",
        }

        this.loadEmployeeProfrom();
    }

    loadEmployeeProfrom() {

        axios.get(window.crmServer+'/job/preformance/min')
            .then(response => {

                if (null == response || undefined == response || 0 == response.data.length) {
                    //
                } else {

                    var employeeProObj = response.data;

                    if (1 == response.data.length ) {
                        this.setState({ imageURL1Week: employeeProObj[0].PROFILE_IMAGE });
                        this.setState({ name1Week: employeeProObj[0].FIRST_NAME });
                    } else {
                        //
                    }

                    if (2 == response.data.length) {
                        this.setState({ imageURL2Week: employeeProObj[1].PROFILE_IMAGE });
                        this.setState({ name2Week: employeeProObj[1].FIRST_NAME });
                    } else {
                        //
                    }

                    if (3 == response.data.length) {
                        this.setState({ imageURL3Week: employeeProObj[2].PROFILE_IMAGE });
                        this.setState({ name3Week: employeeProObj[2].FIRST_NAME });
                    } else {
                        //
                    }

                }

            })
    }

    render() {
        const { data, classes } = this.props;
        return (
            <div>
                <Card className={classes.card}>
                    <div className="w-full flex">
                        <div className="w-full md:w-1/3">
                            <p className="ml-24">1st Week</p>
                            <div className="MuiAvatar-root-915 w-96 h-96 w-full">
                                <img id="profileImg1" src={this.state.imageURL1Week} className="w-96 h-96 rounded-full" />
                            </div>
                            <div className="ml-24">
                                <p>{this.state.name1Week}</p>
                            </div>
                        </div>
                        <div className="w-full md:w-1/3">
                            <p className="ml-24">2nd Week</p>
                            <div className="MuiAvatar-root-915 w-96 h-96 absolute w-full">
                                <img id="profileImg2" src={this.state.imageURL2Week} className="w-96 h-96 rounded-full" />
                            </div>
                            <div className="mt-96 ml-24">
                                <p>{this.state.name2Week}</p>
                            </div>
                        </div>
                        <div className="w-full md:w-1/3">
                            <p className="ml-24">3rd Week</p>
                            <div className="MuiAvatar-root-915 w-96 h-96 absolute w-full">
                                <img id="profileImg3" src={this.state.imageURL3Week} className="w-96 h-96 rounded-full" />
                            </div>
                            <div className="mt-96 ml-24">
                                <p>{this.state.name3Week}</p>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Widget16);



// WEBPACK FOOTER //
// ./src/main/content/apps/dashboards/widgets/Widget16.js